export default __webpack_public_path__ + "static/supportedPlatforms-0156ec65f735481a20119db32ad3cc9f.svg";